import { useSelector } from "react-redux";
import {
  getQuestionById,
  getQuestionsAndAnswers
} from "../../../../store/selectors";
import { useDispatch } from "react-redux";
import {
  QuestionIds,
  questionPresentationContent,
  questionRoutingLabels,
  RadioAndTooltipContent
} from "../../../../data/QuestionPresentation";
import { appraisalSlice } from "../../../../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { sendEvent, setAnalyticsLabel } from "../../../../helpers/analytics";

function useServiceHistory() {
  const QUESTION_ID = QuestionIds.SERVICEHISTORY;
  const NEXT_QUESTION_PATH = questionRoutingLabels[QuestionIds.TAXI];
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const answer = questionsAndAnswers && questionsAndAnswers[QUESTION_ID];
  const factualQuestion = useSelector(getQuestionById("Factual", QUESTION_ID));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pageTitle, subtitle, component: { content } } =
    questionPresentationContent[QUESTION_ID];

  const presentation = content as RadioAndTooltipContent

  const handleSubmit = (answer: string | null) => {
    if (!answer) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("radio"));
    }

    sendEvent("event", "interaction", {
      action: factualQuestion.content,
      label: setAnalyticsLabel(factualQuestion, answer[0])
    });

    navigate(`/${NEXT_QUESTION_PATH}`);
  };

  return {
    question: factualQuestion,
    questionTitle: subtitle,
    pageTitle,
    handleSubmit,
    answer,
    showAsButtons: presentation.showAsButtons,
    replaceManufacturerName: presentation.replaceManufacturerName || false,
  };
}

export default useServiceHistory;
